import { render, staticRenderFns } from "./DataSetDataDialog.vue?vue&type=template&id=07571874&"
import script from "./DataSetDataDialog.vue?vue&type=script&lang=ts&"
export * from "./DataSetDataDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports